import { FC } from 'react'

import styled from 'styled-components'
import { Accordion } from '@mantine/core'

import Logo from 'src/Assets/logo.svg?react'
import { colors } from 'src/Helpers/constants.ts'
import { useMenu } from 'src/Components/Sidebar/useMenu.tsx'

const Container = styled.div<{
  $isCollapsed?: boolean
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 55px;
  background-color: ${colors.mainGray};
  height: 100%;
  padding: 17px;
  border-radius: 15px;
  width: ${({ $isCollapsed }) => ($isCollapsed ? '90px' : '300px')};
  border: 1px solid ${colors.secondGray};
`

const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
`

const StyledAccordion = styled(Accordion)`
  width: 100%;
`

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  gap: 25px;
  padding-bottom: 8px;
`

export const Sidebar: FC = () => {
  const opened = true

  const { itemsList, defaultValue } = useMenu(opened)

  return (
    <Container $isCollapsed={!opened}>
      <Header>
        {opened && (
          <LogoWrapper>
            <Logo />
          </LogoWrapper>
        )}
      </Header>

      <StyledAccordion defaultValue={defaultValue}>{itemsList}</StyledAccordion>
    </Container>
  )
}
